import { render, staticRenderFns } from "./FaqCreate.vue?vue&type=template&id=6486a114"
import script from "./FaqCreate.vue?vue&type=script&lang=js"
export * from "./FaqCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports